import React, { useState } from 'react'
import { T, Icon } from 'components'
import StyledAdvantages from './StyledAdvantages'

const Advantages = ({ contactPhoneNumber }) => {
  const [showAdvantages, toggleAdvantages] = useState(true)

  return (
    <StyledAdvantages showAdvantages={showAdvantages}>
      <i className="advantages-icon mobile-only"></i>
      <h2 onClick={() => toggleAdvantages(!showAdvantages)} className="advantages-heading">
        <T label="payment/membershipAdvantages" /> <Icon name="angle-down" />{' '}
      </h2>
      <div className="advantages-row">
        <span></span>
        <T as="span" label="membership/trial" />
        <T as="span" label="membership/gold" />
        <T as="span" label="membership/vip" />
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/viewVisitors" />{' '}
        <span>
          <Icon name="check" />
        </span>
        <span>
          <Icon name="check" />
        </span>
        <span>
          <Icon name="check" />
        </span>
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/readMessages" /> <span></span>
        <span>
          <Icon name="check" />
        </span>
        <span>
          <Icon name="check" />
        </span>
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/viewProfiles" /> <span></span>
        <span>
          <Icon name="check" />
        </span>
        <span>
          <Icon name="check" />
        </span>
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/viewHotlist" /> <span></span>
        <span>
          <Icon name="check" />
        </span>
        <span>
          <Icon name="check" />
        </span>
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/viewGalleries" /> <span></span>
        <span>
          <Icon name="check" />
        </span>
        <span>
          <Icon name="check" />
        </span>
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/viewZoom" /> <span></span>
        <span>
          <Icon name="check" />
        </span>
        <span>
          <Icon name="check" />
        </span>
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/everyoneReply" /> <span></span>
        <span></span>{' '}
        <span>
          <Icon name="check" />
        </span>
      </div>
      <div className="advantages-row">
        <T as="span" label="payment/getLaidGarantee">
          *
        </T>{' '}
        <span></span>
        <span></span>{' '}
        <span>
          <Icon name="check" />
        </span>
      </div>
      <p className="fine-print">
        * <T label="payment/clickHereForMoreInfo|unsafe" />
        <div className="call-center">
          <T label="payment/callCenter" />
          <strong>{contactPhoneNumber}</strong>
        </div>
      </p>
    </StyledAdvantages>
  )
}

export default Advantages
